import * as React from 'react';
import TractDetailData from 'src/models/tract_detail/TractDetail';
import Form from 'src/components/controls/forms/Form';
import FormTextBox, { FormTextBoxDataType } from 'src/components/controls/forms/redesign/FormTextbox';
import Button from 'src/components/controls/forms/redesign/FormButton';
import PropertyUtil from 'src/util/PropertyUtil';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import FormToggle from 'src/components/controls/forms/redesign/FormToggle';
import FormLabel from 'src/components/controls/forms/FormLabel';
import * as _ from 'lodash';
import { AnyObject, FormApi } from 'final-form';
import SearchResult from 'src/models/OwnerSearchResult';
import './OwnerSearch.scss';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import PhoneNumberType from 'src/models/PhoneNumberType';
import AddOwnershipPages from './AddOwnershipPages';
import OwnerType from './OwnerType';
import { FormErrors } from 'src/util/FormErrors';
import OwnerTypesForms from './OwnerTypesForms';
import { convertInstrumentTypesToSelectList } from 'src/models/InstrumentType';
import AdditionalOwnerSelection from './AdditionalOwnerSelection';

export interface INewOwnerFormProps {
    turnPage: (page: AddOwnershipPages) => void;
    initializeFormAndState: () => void;
    getCityState: (zipCode: string) => void;
    submitOwnership: (values: AnyObject) => void;
    validate: (values: AnyObject) => FormErrors<AnyObject>;
}

export type INewOwnerFormStateProps = {
    dialogType: string;
    tract?: TractDetailData;
    horizon?: number;
    searchResults?: PagedResultSet<SearchResult>;
    ownerTypes: { id: number; name: string }[];
    ownershipType: Array<string>;
    parentOwnershipId?: number;
    phoneNumberTypes: Array<PhoneNumberType>;
    page: AddOwnershipPages;
    states: PagedResultSet<State>;
    isLeasehold?: boolean;
};

type NewOwnerFormState = {
    selectedOwnerType: OwnerType;
    isCommunityProperty: boolean;
};

type INewOwnerFormPageProps = INewOwnerFormProps & INewOwnerFormStateProps;

class NewOwnerForm extends React.Component<INewOwnerFormPageProps, NewOwnerFormState> {
    constructor(props: INewOwnerFormPageProps) {
        super(props);

        this.state = {
            selectedOwnerType: undefined,
            isCommunityProperty: true
        };
    }

    private form: FormApi;
    private ownershipPref: string = this.props.isLeasehold ? 'ownership' : 'contractOwnership';

    selectedOwnerType = (value: OwnerType) => {
        if (value !== undefined) {
            this.setState({ selectedOwnerType: value });
        } else {
            this.setState({ selectedOwnerType: undefined });
        }
    };

    goToFirstPage = () => {
        this.props.initializeFormAndState();

        let initNewOwner = _.cloneDeep(this.form);

        initNewOwner?.change('ownerType', undefined);
        initNewOwner?.change('ownerLookUpId', undefined);
        initNewOwner?.change('searchText', undefined);
        initNewOwner?.change('owners', undefined);
        this.form = initNewOwner;
    };

    validateNewOwnerPopupAndNextPage = () => {
        const formState = this.form.getState();
        if (this.props.page === AddOwnershipPages.NewOwnerDecimalInterest) {
            if (
                (formState.hasValidationErrors && formState.errors.ownership?.decimalInterest) ||
                formState.errors.ownership?.additionalOwnershipTypeId
            ) {
                console.log('form errors', formState);
                window.alert('Please Fill Out All Required Fields To Continue');
            } else {
                this.props.turnPage(AddOwnershipPages.NewOwnerVestingInterestForm);
            }
        } else if (this.props.page === AddOwnershipPages.NewOwnerVestingInterestForm) {
            if (formState.hasValidationErrors ||
                formState.errors.ownership?.additionalOwnershipTypeId) {
                console.log('form errors', formState);
                window.alert('Please Fill Out All Required Fields To Continue');
            } else {
                this.props.submitOwnership(this.form.getState().values);
            }
        } else if ( // user is on first info page
            formState.hasValidationErrors &&
            (formState.errors.individualOwner ||
                formState.errors.ownerTrust ||
                formState.errors.businessOwner ||
                formState.errors.bolmOwner ||
                formState.errors.ralOwner ||
                formState.errors.stateLandOwner ||
                formState.errors.ownerJointTenant)
        ) {
            console.log('form errors', formState);
            window.alert('Please Fill Out All Required Fields To Continue');
        } else {
            this.props.turnPage(AddOwnershipPages.NewOwnerDecimalInterest);
        }
    };

    onChangeCommunityPropertyToggle = (value: string) => {
        this.setState({ isCommunityProperty: value === 'Yes' ? false : true });
    };

    render() {
        return (
            <Form
                onFormCreated={(form) => (this.form = form)}
                onSubmit={this.validateNewOwnerPopupAndNextPage}
                hasFieldArray={true}
                keepDirty={true}
                // showDebugValues={true}
                initialValues={{
                    // Check if these are needed
                    horizonId: PropertyUtil.SafeGet(() => this.props.tract?.horizons[this.props.horizon].id),
                    parentOwnershipId: this.props.parentOwnershipId,
                }}
                validate={this.props.validate}
            >
                <div>
                    {this.props.page === AddOwnershipPages.NewOwnerInfoForm && (
                        <>
                            <span className="bp3-label">Owner Type</span>
                            <div>
                                <FormSelect
                                    name="ownerType"
                                    items={this.props.ownerTypes}
                                    onChange={this.selectedOwnerType}
                                    className="lh-fifth-width"
                                />
                            </div>

                            {PropertyUtil.SafeGet(() => this.state.selectedOwnerType) === undefined && (
                                <div>
                                    <Button text="Previous" onClick={this.goToFirstPage} />
                                </div>
                            )}
                            <OwnerTypesForms
                                form={this.form}
                                getCityState={this.props.getCityState}
                                next={this.validateNewOwnerPopupAndNextPage}
                                prev={this.goToFirstPage}
                                phoneNumberTypes={this.props.phoneNumberTypes}
                                selectedOwnerType={this.state.selectedOwnerType}
                                states={this.props.states}
                            />
                        </>
                    )}
                </div>
                <div>
                    {this.props.page === AddOwnershipPages.NewOwnerDecimalInterest && (
                        <>
                            <div>
                                <span>New Owner</span>
                            </div>

                            {/* <FormSelect
                                        name={`${this.ownershipPref}.ownershipType`}
                                        label="Ownership Type"
                                        defaultOption={'FEE'}
                                        items={[new SelectItem(0, 'FEE')]}
                                        className="lh-half-width"
                                    /> */}
                            <div>
                                <FormTextBox
                                    name={`${this.ownershipPref}.decimalInterest`}
                                    label="Decimal Interest"
                                    className="lh-half-width"
                                    isRequired={true}
                                />
                                {this.props.parentOwnershipId > 0 && this.props.dialogType === 'ADD_ADDITIONAL_OWNERSHIP' && (
                                    <AdditionalOwnerSelection
                                        namePrefix={`${this.ownershipPref}.`}
                                        revertNpri={() => this.form.change(`${this.ownershipPref}.npriStatus`, undefined)}
                                    />
                                )}
                            </div>
                            <div style={{ width: '400px', display: (this.state.selectedOwnerType !== OwnerType.Individual ? 'none' : 'inline-block') }}>
                                <FormLabel text="Sole and Separate Property (SSP)?" />
                                <div style={{ width: '100px' }}>
                                    <FormToggle onChange={this.onChangeCommunityPropertyToggle} name={`${this.ownershipPref}.isCommunityProperty`} items={['Yes', 'No']} />
                                </div>
                            </div>

                            <div>
                                <Button text="Prev" onClick={() => this.props.turnPage(AddOwnershipPages.NewOwnerInfoForm)} />
                                <Button text="Next" onClick={() => this.validateNewOwnerPopupAndNextPage()} />
                            </div>
                        </>
                    )}
                </div>
                <div>
                    {this.props.page === AddOwnershipPages.NewOwnerVestingInterestForm && (
                        <>
                            <div>
                                <FormTextBox
                                    name={`${this.ownershipPref}.vestingDeedReference`}
                                    label="Vesting Deed Reference"
                                    className="lh-third-width"
                                />
                                <FormTextBox
                                    name={`${this.ownershipPref}.vestingDeedDate`}
                                    label="Vesting Deed Date"
                                    className="lh-third-width"
                                    type={FormTextBoxDataType.Date}
                                />
                            </div>
                            <div>
                                <FormSelect
                                    name={`${this.ownershipPref}.vestingDeedInstrumentType`}
                                    items={convertInstrumentTypesToSelectList()}
                                    label="Vesting Deed Instrument Type"
                                    className="lh-third-width"
                                />
                                <FormTextBox
                                    name={`${this.ownershipPref}.vestingDeedInstrumentSource`}
                                    label="Vesting Deed Instrument Source"
                                    className="lh-third-width"
                                />
                            </div>
                            <div>
                                <Button text="Prev" onClick={() => this.props.turnPage(AddOwnershipPages.NewOwnerDecimalInterest)} />
                                <Button type="submit" text="Add Ownership" intent="primary" onClick={() => console.log('button clicked')} />
                            </div>
                        </>
                    )}
                </div>
            </Form>
        );
    }
}

export default NewOwnerForm;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/NewOwnershipForm.tsx